import { marketplaceApi } from '.';

export async function cancelMarketplaceOrder(orderId: string) {
	return (await marketplaceApi).postMarketplaceOrderCancelByOrderId(orderId).then(res => res.data);
}
